import { Injectable, Injector } from '@angular/core';
import { EventsStore } from '../../common-page-components/stores/entities-store/events-store';
import { HttpClient } from '@angular/common/http';
import { WaHelperService } from '../../library/wa-services/wa-helper-service';
import { CompetitionIndividualRankingsStore, CompetitionStore, QuotesCompetitionStore } from 'src/app/common-page-components/stores/entities-store/competition-store';
import { CompetitionsNewsStore } from 'src/app/common-page-components/stores/entities-store/competitions-news-store';
import { CompetitionsGalleryStore } from '../../common-page-components/stores/entities-store/competitions-gallery.store.';
import { CompetitionDocumentStore } from '../../common-page-components/stores/entities-store/competition-documents-store'
import { CompetitionInformationStore } from '../../common-page-components/stores/entities-store/competition-store';
import { CompetitionsDayReviewNewsStore } from '../../common-page-components/stores/entities-store/competitions-day-review-news-store';
@Injectable({
  providedIn: 'root'
})
export class CompetitionInitService {

  /**
   * The ranking store items.
   *
   * @memberof FiltersCompetitionRankingService
   */
  rankingStore = new CompetitionIndividualRankingsStore(this.http, this.injector)

  /**
   * The competition news store.
   *
   * @type {CompetitionsNewsStore}
   * @memberof CompetitionInitService
   */
  competitionNewsStore: CompetitionsNewsStore = new CompetitionsNewsStore(this.http);

  /**
   * The competition day review news store.
   *
   * @type {CompetitionsNewsStore}
   * @memberof CompetitionInitService
   */
  competitionDayReviewNewsStore: CompetitionsDayReviewNewsStore = new CompetitionsDayReviewNewsStore(this.http);

  /**
   * The competition store.
   *
   * @memberof CompetitionInitService
   */
  competitionStore = new CompetitionStore(this.http, this.injector);

  /**
   * The competitions gallery store.
   *
   * @memberof CompetitionInitService
   */
  competitionGalleryStore = new CompetitionsGalleryStore(this.injector, this.http);

  /**
   * The competitions document store from the tofficial service.
   *
   * @memberof CompetitionInitService
   */
  competitionDocumentsStore = new CompetitionDocumentStore(this.http, this.injector);

  /**
   * The competition editorial information store.
   *
   * @memberof CompetitionInitService
   */
  competitionEditorialInformationStore = new CompetitionInformationStore(this.http, this.injector);

  /**
   * The competition quotes store.
   *
   * @memberof CompetitionInitService
   */
  competitionQuotes = new QuotesCompetitionStore(this.http, this.injector, undefined);
  constructor(private http: HttpClient, private injector: Injector) {

  }

  /**
   * Method for get the photos from api.
   *
   * @memberof CompetitionInitService
   */
  getPhotos() {
    return this.competitionGalleryStore.requestData({}, false);
  }

  /**
 * A method for prepare the competition name for route
 * @returns {string} the competition name with '-' instead spaces.
 * @memberof CompetitionInitService
 */
  prepareNameForRoute(name: string) {
    // TO DO make the name the same https://worldarchery.sport/competition/19890/medellin-2019-archery-world-cup-world-ranking-event#/#official
    let namePrepared = name.toLocaleLowerCase().split(' ').join('-').split('/').join('-');
    if (namePrepared.substr(namePrepared.length - 1, 1) === '-') {
      namePrepared = namePrepared.substring(0, namePrepared.length - 1);
    }
    return namePrepared;
  }

  /**
   * Method for get the competition name in the router and pass it to Angular js.
   *
   * @returns
   * @memberof CompetitionInitService
   */
  getCompetitionNameAndIdForRouterNavigate() {
    const name = this.prepareNameForRoute(this.competitionStore.data[0].Name);
    const competitionID = this.competitionStore.data[0].ID;
    return {
      name: name,
      id: competitionID
    }
  }
}
